var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$detect == 'mobile' && _vm.show)?_c('div',{class:{
        'ldc-option-mobile-item px-3': true,
    },on:{"click":function($event){return _vm.selectOption()}}},[(_vm.$isAndroid)?_c('div',[_c('i',{class:{
            'icon mr-3': true,
            'ion-md-radio-button-off': _vm.model !== _vm.value || (_vm.labelModel === '' && _vm.value === ''),
            'ion-md-radio-button-on text-primary': _vm.model === _vm.value && _vm.labelModel !== '',
        }}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.label))])]):_c('div',{class:{
            'position-relative': true,
            'active-ios-option text-primary': _vm.model === _vm.value && _vm.labelModel !== '',
        }},[_c('span',[_vm._v(_vm._s(_vm.label))]),(_vm.model === _vm.value && _vm.labelModel !== '')?_c('i',{staticClass:"ion ion-md-checkmark position-absolute"}):_vm._e()])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }